import NavItem from './NavItem';
import { useVesselStore } from '../../../context/VesselContext';
import useAppFeature from '../../../app/useAppFeature';
import { AppFeatureEnum } from '../../../enums/appFeatureEnum';
import { useAuthStore } from '../../../context/AuthContext';
import PBIMenu from '../../../pages/pbi-report/PBIMenu';
import { useState } from 'react';
import { BiReportMenuItem, BiReportMenuWrapper, TopMenuItemsWrapper, BottomMenuItemsWrapper } from './SidePanelLeft.styles';
import { SidePanelLeftWrapper } from 'src/App.styles';
import { hasPermission } from 'src/utils/stowage/permissions/stowagePermissionsUtils';
import { stowageFeatureEnum } from 'src/enums/stowage/stowageFeatureEnum';
import { isShipUserRole } from 'src/utils/verification/verificationUtils';

const SidePanelLeft = () => {
    const [hoverTimeout, sethoverTimeout] = useState<NodeJS.Timeout>(null);
    const [pbiMenuOpen, setPbiMenuOpen] = useState<boolean>(false);
    const { selectedVessel } = useVesselStore();
    const { isFeatureEnabled } = useAppFeature();
    const { role } = useAuthStore();

    const handleMouseEnter = () => {
        setPbiMenuOpen(true);
        clearTimeout(hoverTimeout);
    };

    const handleMouseLeave = () => {
        const timer = setTimeout(() => {
            setPbiMenuOpen(false);
        }, 500);
        sethoverTimeout(timer);
    };

    const featureEnabled = !!(role && isFeatureEnabled({ featureEnum: AppFeatureEnum.Verification, date: new Date(), role: role.roleType }));
    const isShipUser = !!(role && isShipUserRole(role));
    const showVerificationMenu =
        featureEnabled &&
        !(isShipUser && (!selectedVessel || selectedVessel.hasOrcaWebSimpleMode));
        

    return (
        <SidePanelLeftWrapper>
            <TopMenuItemsWrapper>
                {isFeatureEnabled({ featureEnum: AppFeatureEnum.Stowage, date: new Date(), imoNumber: selectedVessel?.imoNumber }) &&
                    hasPermission(role, stowageFeatureEnum.ViewStowagePlan) && (
                        <NavItem title={'Stowage'} path={'stowage'} iconName="table" ignoreQueryParams={true} />
                    )}
                <NavItem title={'Events'} path={'report-events'} iconName="calendar-check" />
                <NavItem title={'AOL'} path={'aol'} iconName="file-alt" />
                {isFeatureEnabled({ featureEnum: AppFeatureEnum.Bunkering, date: new Date(), imoNumber: selectedVessel?.imoNumber }) && (
                    <NavItem title={'Bunker'} path={'bunkering'} iconName="gas-pump" ignoreQueryParams={true} />
                )}
                {selectedVessel &&
                    !selectedVessel.hasOrcaWebSimpleMode &&
                    isFeatureEnabled({
                        featureEnum: AppFeatureEnum.CargoTemperatureControlLog,
                        date: new Date(),
                    }) && <NavItem title={'Cargo Temp'} path={'cargo-temp-log'} iconName="temperature-high" />}
                {selectedVessel &&
                    !selectedVessel.hasOrcaWebSimpleMode &&
                    isFeatureEnabled({ featureEnum: AppFeatureEnum.CargoConsumable, date: new Date() }) && (
                        <NavItem title={'Consum ables'} path={'tank-cleaning'} iconName="database" />
                    )}
            </TopMenuItemsWrapper>
            <BottomMenuItemsWrapper>
                {showVerificationMenu && <NavItem title={'Verifica tion'} path={'verification'} iconName="certificate" bottomMenu={true} />}
                <BiReportMenuWrapper onMouseLeave={handleMouseLeave}>
                    {selectedVessel && isFeatureEnabled({ featureEnum: AppFeatureEnum.PbiReports, date: new Date() }) && (
                        <BiReportMenuItem onMouseEnter={() => handleMouseEnter()}>
                            <NavItem title={'Dash boards'} path={'dashboards'} iconName="chart-line" bottomMenu={true} disabled />
                            {pbiMenuOpen && <PBIMenu />}
                        </BiReportMenuItem>
                    )}
                </BiReportMenuWrapper>
            </BottomMenuItemsWrapper>
        </SidePanelLeftWrapper>
    );
};

export default SidePanelLeft;
